(ns dashboard.views.recommendation.recommend-question
  (:require ["react" :as react]
            [dashboard.entity.analysis.search :as analysis.search]
            [dashboard.entity.question.search :as question.search]
            [dashboard.entity.recommendation.profile :as recommendations]))

(defn- RecommendQuestion-1-SelectQuestionAndAnswer
  "Recommendation Step 1.
   Accepts a map with required keys:
   - question
   - on-question-selected
   - filter-actions
   - initial-search
   - hide-input
   - path
   - search-actions"
  [props #_{:keys [question
                   on-question-selected
                   filter-actions
                   initial-search
                   hide-input
                   path
                   search-actions] :as props}]
  [:<>
   [:f> recommendations/ProcessSteps
    "Choose the Most Appropriate Question to build your answer from"
    [:div
     [:p [:b "Step 1:"] " Click to select the most fitting Question & Answer."]
     [:p "Choose from the list of other questions and answers, that we will use
          to build this response from."]]
    "Build Answer from Similar Questions & Answers"
    :recommended-question-process
    [{:class :is-info}
     {:disabled true
      :class :is-tertiary}]]
   [:div.recommend-question--analysis-search.recommender--step
    [:h6.is-5.title.mt-0.mb-4.pb-4
     "Step 1: Select an Previous Question & Answer"]
    [:form
     {:style {:position "sticky" :top 0 :display "contents"}
      :on-submit (fn [e] (.preventDefault e))}
     [:f> question.search/QuestionSearch props]]]])

(defn- RecommendQuestion-2-FillAnswerWithSelectedQuestion
  "Recommend Question Step 2: Fill Repsonse for Selected Question

   Accepts Keys:
   - question
   - data
   - on-question-selected
   - selected-question
   - preselected-construct-ids
   - set-selected-question
   - all-analyses
   - checked
   - set-checked
   - answer-options
   - set-answer-options
   - on-submit"
  [{:keys [question
           data
           on-question-selected
           selected-question
           preselected-construct-ids
           set-selected-question
           all-analyses
           checked
           set-checked
           answer-options
           set-answer-options
           on-submit]}]
  [:<>
   [:f> recommendations/ProcessSteps
    "Choose the Most Appropriate Question to build your answer from"
    [:div
     [:p [:b "Step 2:"] " Choose the parts of the question to fill your response"]
     [:p "Select the portions of the Selected Answer to use to build your response"]]
    "Build Answer from Similar Questions & Answers"
    :recommended-question-process
    [{:class :is-secondary
      :on-click #(set-selected-question nil)}
     {:class :is-info}]]
   [:div.level-left.is-align-items-start.questions--process-step-container
    [:button.button.is-secondary
     {:on-click #(set-selected-question nil)
      :style {:margin "32px 12px 0 0"}}
     [:i.icon.fas.fa-caret-left]]
    [:div.recommender--step.is-flex-grow-1
     [:f> recommendations/SelectedQuestion->Response
      {:step-number 2
       :question question
       :on-question-selected on-question-selected
       :selected-question selected-question
       :already-linked-construct-ids preselected-construct-ids
       :recommended-analyses (:structures data)
       :all-analyses all-analyses
       :checked checked
       :set-checked set-checked
       :answer-options answer-options
       :set-answer-options set-answer-options}]]]
   [recommendations/Footer
    all-analyses
    (-> question :selected-answer :applied-analyses)
    checked
    selected-question
    on-submit
    answer-options]])


(defn recommend-questions
  "Recommend Similar Question and Answer.
   In order to recommend a question and answer, we require a reference
   question as well as handler that will add the various components of
   the end result selection to the answer for the reference question.

   All re-frame state is handled internally via analysis.search getters
   and setters, and is saved to [:analysis-search :questions (:id question)]

   Accepts a map with keys:
   - question - a question entity
   - on-submit - an arity-2 function that accepts arguments:
                 - coll - a collection of analysis structures to be added to an
                          answer
                 - answer-data - a map containing maybe keys:
                                 - response
                                 - additional-information"
  [{:keys [question on-submit]}]
  (let [path [:analysis-search :questions (:id question)]
        data @(analysis.search/get-search-results* path)
        search-query @(analysis.search/get-search-query* path (:content question))
        selected-question @(analysis.search/get-selected-question* (conj path :recommended-question))
        set-selected-question (partial analysis.search/set-selected-question (conj path :recommended-question))
        [checked set-checked] (react/useState #{})
        [answer-options set-answer-options] (react/useState {})
        preselected-construct-ids (->> question
                                       :selected-answer
                                       :applied-analyses
                                       (remove :next-version-id)
                                       (mapv :construct-id)
                                       set)
        on-question-selected (fn [selected-question]
                               (set-selected-question selected-question)
                               (set-answer-options
                                (when selected-question
                                  {:response true
                                   :additional-information true
                                   :analysis true
                                   :recommended-analysis (-> selected-question
                                                             :analyses
                                                             count
                                                             zero?)}))
                               (when selected-question
                                 (set-checked
                                  (->> selected-question
                                       :analyses
                                       (remove (comp preselected-construct-ids
                                                     :construct-id))
                                       (mapv #(select-keys % [:construct-id
                                                              :version-id]))
                                       set))))
        all-analyses @(analysis.search/all-analysis-structures)
        props {:question question
               :data  data
               :path path
               :initial-search {:query search-query
                                :mode :semantic}
               :selected-question selected-question
               :preselected-construct-ids preselected-construct-ids
               :all-analyses all-analyses
               :checked checked
               :answer-options answer-options
               :on-question-selected on-question-selected
               :set-checked set-checked
               :set-answer-options set-answer-options
               :set-selected-question set-selected-question
               :on-submit on-submit}]
    (if-not selected-question
      [:f> RecommendQuestion-1-SelectQuestionAndAnswer props]
           ;else
      [RecommendQuestion-2-FillAnswerWithSelectedQuestion props])))
